import React, { useEffect, useState, useRef } from "react";
import Link from "components/Link";
import {
  getStorage,
  referensiSecurityPage,
  removeStorage,
  getStorageParse,
} from "pages/Utils";
import { usePathname } from "components/Navigation";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import $ from "jquery";
import { useSelector, useDispatch } from "react-redux";
import { VAR_IS_PAGE_404, VAR_IS_PAGE_READONLY } from "hooks/redux";

const ApplicationMenu = (props) => {
  const pathname = usePathname();
  const dispatch = useDispatch();
  const [data_menu, setdata_menu] = useState([]);
  const [menu_clicked, setmenu_clicked] = useState(0);
  const [init_menu, setinit_menu] = useState(false);
  const [page_active, setpage_active] = useState("");
  const [sidebar_collapsed, setsidebar_collapsed] = useState(false);

  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initMenu();
    }
  }, []);

  useEffect(() => {
    removeStorage("id_profile");
    removeStorage("jenis_param");
    if (init_menu) {
      initMenuActive();
    }
  }, [pathname]);

  useEffect(() => {
    if (data_menu && data_menu.length > 0 && init_menu) {
      handleSecurityPage();
    }
  }, [data_menu]);

  const initMenu = async () => {
    const user_login = getStorageParse("user_login");

    const menu = resInitMenuTree(user_login.menu);

    setdata_menu(menu);
    setinit_menu(true);

    renderMenu(menu);

    initsidebar_collapsed();
  };

  const initsidebar_collapsed = () => {
    // // console.log('initsidebar_collapsed')
    const body_classname = $("body").attr("class");
    // // console.log('body_classname')
    // // console.log(body_classname.attr('class'))

    if (body_classname)
      if (body_classname.includes("sidebar-collapsed")) {
        setsidebar_collapsed(true);
      } else {
        setsidebar_collapsed(false);
      }
  };

  const resInitMenuTree = (data) => {
    initMenuTree(data);
    return data;
  };

  const initMenuTree = (data) => {
    data.forEach((m) => {
      const pathname_arr = pathname.split("/");
      const page = pathname_arr[1];

      const pagearr = `${m.page}`.split("/");
      const mpage = pagearr[0];
      // m.active = `${m.page}` === page ? true : false

      m.active = `${mpage}` === page ? true : false;
      if (
        mpage == "mt_risk_kriteria_dampak" ||
        mpage == "kriteria_kemungkinan"
      ) {
        m.active = pathname === `/${m.page}` ? true : false;
        if (pathname_arr.length > 3) {
          let pathnamecut = "";
          pathname_arr.map((x, y) => {
            if (y < 3 && x) {
              pathnamecut += "/";
              pathnamecut += x;
            }
          });

          m.active = `/${m.page}` === pathnamecut ? true : false;
        }
      }
      if (init_menu) {
        m.collapsed = m.collapsed;
      } else {
        m.collapsed = true;
      }

      if (m.submenu && m.submenu.length > 0) {
        initMenuTree(m.submenu);
      }
    });
  };

  const setParentActive = (menu) => {
    // Periksa apakah menu memiliki properti `sub_menu`
    if (Array.isArray(menu.submenu)) {
      // Periksa setiap submenu secara rekursif
      menu.submenu.forEach(setParentActive);

      // Cek jika salah satu submenu aktif
      const hasActiveChild = menu.submenu.some(
        (child) => child.active === true
      );
      if (hasActiveChild) {
        menu.active = true;
      }
    }

    // Jika menu ini sendiri memiliki properti `active`, pertahankan nilainya
    if (
      menu.active !== true &&
      menu.hasOwnProperty("active") &&
      menu.active === true
    ) {
      menu.active = true;
    }
  };

  const initMenuActive = () => {
    setmenu_clicked(menu_clicked + 1);
    let menu = resInitMenuTree(data_menu);
    // // console.log('menu');
    // // console.log(menu);
    menu.forEach(setParentActive);
    // // console.log('menup');
    // // console.log(menup);

    setdata_menu(menu);

    // // console.log('menu')
    // // console.log(menu)
    // const menu_active = func_menu_active(menu)
    // menu.forEach(m => {

    // })

    dispatch({
      type: VAR_IS_PAGE_READONLY,
      value: false,
    });

    handleSecurityPage(menu);
  };

  const func_menu_active = (data) => {
    data.forEach((m) => {
      if (m.active) {
        return m;
      }
      if (m.submenu && m.submenu.length > 0) {
        func_menu_active(m.submenu);
      }
    });
  };

  const handleClickMenu = (item_menu) => {
    // // console.log('item_menu')
    // // console.log(item_menu)
    setmenu_clicked(menu_clicked + 1);

    const data_menu_res = func_data_menu_foreach(data_menu, item_menu);
    setdata_menu(data_menu_res);
  };

  const func_data_menu_foreach = (data_menu, item_menu) => {
    data_menu_foreach(data_menu, item_menu);
    return data_menu;
  };

  const data_menu_foreach = (data_menu, item_menu) => {
    return data_menu.forEach((m, i) => {
      // if (m.page === item_menu.page) {
      //     m.collapsed = m.collapsed ? false : true
      // }
      if (m.id_menu === item_menu.id_menu) {
        m.collapsed = m.collapsed ? false : true;
      }
      // else{
      //     m.collapsed = true;
      // }
      if (m.submenu !== undefined && m.submenu.length > 0) {
        data_menu_foreach(m.submenu, item_menu);
      }
    });
  };

  // const renderMenu = (data_menu) => {
  //   return data_menu.map((m, i) => {
  //     let children_exists = false;
  //     if (m.submenu !== undefined && m.submenu.length > 0) {
  //       children_exists = true;
  //     }
  //     return (
  //       <li
  //         className={`sidebar-li ${m.active ? "active" : ""} ${m.collapsed === true ? "collapsed" : ""
  //           }`}
  //         key={i}
  //       >
  //         {/* {m.submenu !== undefined && m.submenu.length > 0 ? (
  //                       <Link href="#" className={`sidebar-a ${m.active ? 'active' : ''} ${children_exists ? "children-exists" : ""}`} onClick={() => handleClickMenu(m)}>
  //                           <span className="material-icons">{m.icon ? m.icon : 'pie_chart'}</span>
  //                           <span className='sidebar-a-label'>{m.label}</span>
  //                       </Link>
  //                   ) : (
  //                   )} */}
  //         {/* <Link href={children_exists ? "#" : `/${m.page}`} className={`sidebar-a ${m.active ? 'active' : ''} ${children_exists ? "children-exists" : ""}`} onClick={() => children_exists ? handleClickMenu(m) : null}>
  //                       <span className="material-icons">{m.icon ? m.icon : 'pie_chart'}</span>
  //                       <span className='sidebar-a-label'>{m.label}</span>
  //                   </Link> */}
  //         <ItemMenu
  //           id_menu={m.id_menu}
  //           label={m.label}
  //           icon={m.icon ? m.icon : null}
  //           children_exists={children_exists}
  //           active={m.active}
  //           page={m.page}
  //           onClickMenu={handleClickMenu}
  //           sidebar_collapsed={sidebar_collapsed}
  //           data={m}
  //         />
  //         {m.submenu !== undefined && m.submenu.length > 0 ? (
  //           <ul
  //             className={`sidebar-ul ${m.collapsed === true ? "collapsed" : ""
  //               }`}
  //           >
  //             {renderMenu(m.submenu)}
  //           </ul>
  //         ) : null}
  //       </li>
  //     );
  //   });
  // };

  const renderMenu = (data_menu, level = 0) => {
    return data_menu.map((m, i) => {
      const children_exists = m.submenu?.length > 0;
      const indentLevel = level >= 2 ? (level - 1) * 16 : 0;

      return (
        <li
          key={i}
          className={`sidebar-li ${m.active ? "active" : ""} ${
            m.collapsed ? "collapsed" : ""
          }`}
          style={{ paddingLeft: `${indentLevel}px` }}
        >
          <ItemMenu
            id_menu={m.id_menu}
            label={m.label}
            icon={m.icon ? m.icon : null}
            children_exists={children_exists}
            active={m.active}
            page={m.page}
            onClickMenu={handleClickMenu}
            sidebar_collapsed={sidebar_collapsed}
            data={m}
          />

          {children_exists && (
            <ul className={`sidebar-ul ${m.collapsed ? "collapsed" : ""}`}>
              {renderMenu(m.submenu, level + 1)}
            </ul>
          )}
        </li>
      );
    });
  };

  const handleSecurityPage = () => {
    const pathname_arr = pathname.split("/");
    const page = pathname_arr[1];
    // console.log("handleSecurityPage");
    // console.log(data_menu);
    // console.log(page);
    // console.log(pathname_arr);

    const checkpage = referensiSecurityPage(data_menu, page, pathname_arr);
    // console.log("checkpage");
    // console.log(checkpage);
    dispatch({
      type: VAR_IS_PAGE_404,
      value: checkpage.is_error ? true : false,
    });
  };

  return <ul className="sidebar-ul">{renderMenu(data_menu)}</ul>;
};

export default ApplicationMenu;

const ItemMenu = (propsx) => {
  const total_ews = useSelector((state) => state.total_ews);
  const [show, setShow] = useState(false);
  const target = useRef(null);

  const handleShow = () => {
    // // console.log('handleShow')
    if (checksidebar_collapsed()) {
      setShow(true);
    }
  };
  const handleHide = () => {
    if (checksidebar_collapsed()) {
      setShow(false);
    }
  };

  const checksidebar_collapsed = () => {
    // // console.log('initsidebar_collapsed')
    const body_classname = $("body").attr("class");
    // console.log("body_classname");
    // console.log(body_classname);

    if (body_classname && body_classname.includes("sidebar-collapsed")) {
      return true;
    }
    return false;
  };

  return (
    <>
      {/* <span
                className="material-icons"
                ref={target}
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
            >
                {propsx.icon}
            </span> */}
      <Link
        // ref={target}
        href={propsx.children_exists ? "#" : `/${propsx.page}`}
        className={`sidebar-a ${propsx.active ? "active" : ""} ${
          propsx.children_exists ? "children-exists" : ""
        }`}
        onClick={() =>
          propsx.children_exists ? propsx.onClickMenu(propsx.data) : null
        }
        // onMouseEnter={handleShow}
        // onMouseLeave={handleHide}
      >
        {propsx.icon ? (
          <span className="material-icons">{propsx.icon}</span>
        ) : null}
        <span className="sidebar-a-label">
          {propsx.label}{" "}
          {propsx.label == "Early Warning System" && total_ews ? (
            <span className="item-count-ews">{total_ews}</span>
          ) : null}
        </span>
      </Link>
      <Overlay target={target.current} show={show} placement="right">
        {(props) => (
          <Tooltip
            //  style={{ position: 'fixed' }}
            id={`overlay-example_${propsx.id_menu}`}
            {...props}
          >
            {propsx.label}
          </Tooltip>
        )}
      </Overlay>
    </>
  );
};
